<script lang="ts" setup></script>

<template>
  <div class="layout">
    <header class="c-header">
      <div class="c-header-inner">
        <NuxtLink to="/dashboard" class="logo">
          <img src="@/assets/images/nibe-logo.svg" width="80" />
        </NuxtLink>
        <NavigationUser />
      </div>
    </header>

    <div class="test lg:flex lg:flex-row-reverse lg:justify-center">
      <div class="layout__content">
        <div class="flex min-h-full w-full justify-center">
          <main class="content__slot w-full lg:max-w-container-xl">
            <slot></slot>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.layout {
  @apply h-screen w-screen;
  @apply max-h-screen max-w-[100vw];
  @apply min-h-screen min-w-[100vw];
  font-family: 'PT-Sans';
  color: var(--user-dashboard-color-text);
  background-color: var(--user-dashboard-color-background);

  .test {
    height: var(--content-height-without-header);
    max-height: var(--content-height-without-header);
    min-height: var(--content-height-without-header);
  }

  .layout__content {
    @apply w-full overflow-hidden;
    height: calc(var(--content-height-without-header) - 1px);
    background-color: var(--user-dashboard-color-background);

    @media (min-width: 1024px) {
      @apply h-full;
    }

    @apply overflow-y-auto overflow-x-hidden;
    @apply bg-gray-50;

    .content__slot {
      @apply min-h-full;
      @apply p-4;
      @apply pt-0;

      @media (min-width: 1024px) {
        @apply p-6;
        @apply pt-0;
      }
    }
  }
}
</style>
